// extracted by mini-css-extract-plugin
export default {"solution":"decision_qpc_list-module__solution--956Uz"};